import request from "http/request";
import endpointMaker from "appredux/endpoints";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getHorsesFromLocalStorage,
  getHorseProfileFromLocalStorage,
  getHorseScheduleFromLocalStorage,
  getHorseTemperaturesFromLocalStorage,
  getHorseUpcomingShowsFromLocalStorage,
} from "appredux/utils";

export const getHorseData = createAsyncThunk("horseList", async (farm: string) => {
  const cachedHorseData = getHorsesFromLocalStorage(farm);
  if (cachedHorseData) return cachedHorseData;

  return request.getJson(endpointMaker.api.horsesByFarm(farm), true, null);
});

export const getHorseTemperatureData = createAsyncThunk(
  "horseTemperatures",
  async (farm: string) => {
    const cachedHorseData = getHorseTemperaturesFromLocalStorage(farm);
    if (cachedHorseData) return cachedHorseData;

    return request.getJson(endpointMaker.api.horsesTempsByFarm(farm), true, null);
  }
);

export const getHorseUpcomingShows = createAsyncThunk(
  "horseUpcomingShows",
  async (microchip: string) => {
    const cachedHorseData = getHorseUpcomingShowsFromLocalStorage(microchip);
    if (cachedHorseData) return cachedHorseData;

    return request.getJson(
      endpointMaker.api.horseUpcomingShows(microchip, localStorage.getItem("farm")),
      true,
      null
    );
  }
);

export const getHorseProfile = createAsyncThunk("horseProfile", async (microchip: string) => {
  const cachedHorseData = getHorseProfileFromLocalStorage(microchip);
  if (cachedHorseData) return cachedHorseData;

  return request.getJson(
    endpointMaker.api.horseProfile(microchip, localStorage.getItem("farm")),
    true,
    null
  );
});

export const getHorseSchedule = createAsyncThunk("horseSchedule", async (microchip: string) => {
  const cachedHorseSchedule = getHorseScheduleFromLocalStorage(microchip);
  if (cachedHorseSchedule) return cachedHorseSchedule;

  return request.getJson(
    endpointMaker.api.horseSchedule(microchip, localStorage.getItem("farm")),
    true,
    null
  );
});
